/**
 * The 404 component
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
import Page from "../components/Page";
import ScrollToTop from "../components/Utils/Scroll/ScrollToTop";
import nfgclosed from "../assets/images/nfg-closed.jpeg";
import nfgredemption from "../assets/images/nfg-redemption.jpeg";

const Collections = (props, context) => {
  return (
    <Page title={context.t("All NFG Collections")}>
      <ScrollToTop />
      <Container>
        <Row>
          <Col xs={12}>
            <h1>{context.t("All NFG Collections")}</h1>
          </Col>
        </Row>
        <div className="my-5">
          <a
            href="https://www.niftygateway.com/marketplace/collection/0x88bfe418f44f367200e683ed7981f6e02363a041"
            target="_blank"
            rel="noreferrer"
            title="NFG by ART2PEOPLE x Mercedes-Benz G-Wagon"
          >
            <h2>NFG by ART2PEOPLE x Mercedes-Benz G-Wagon</h2>
            <img
              src={nfgclosed}
              alt="NFG by ART2PEOPLE x Mercedes-Benz G-Wagon"
              className="w-100"
            />
          </a>
        </div>
        <div className="my-5">
          <a
            href="https://www.niftygateway.com/marketplace/collection/0x391f1f7566e70734bd07852f7c0649ddc80bd69e"
            target="_blank"
            rel="noreferrer"
            title="NFG Open Editions by ART2PEOPLE x Mercedes-Benz G-Wagon"
          >
            <h2>NFG Open Editions by ART2PEOPLE x Mercedes-Benz G-Wagon</h2>
            <img
              src={nfgclosed}
              alt="NFG Open Editions by ART2PEOPLE x Mercedes-Benz G-Wagon"
              className="w-100"
            />
          </a>
        </div>
        <div className="my-5">
          <a
            href="https://www.niftygateway.com/marketplace/collection/0x1a4c685f6ebfaa429a11a58b96967a8fb7a5a4c4"
            target="_blank"
            rel="noreferrer"
            title="NF-G Redemption"
          >
            <h2>NF-G Redemption</h2>
            <img src={nfgredemption} alt="NF-G Redemption" className="w-100" />
          </a>
        </div>
      </Container>
    </Page>
  );
};
/**  define proptype for the 'translation' function  */
Collections.contextTypes = {
  t: PropTypes.func,
};
export default Collections;
